jQuery(function($) {
  "use strict";

  vector.smoothScrollAll();
  vector.menuDropdown(".header__inner li.menu-item-has-children");
  vector.mobileMenu(
    "#mobile__menu",
    "#mobile__menu--button",
    "#mobile__menu--screen",
  );

  // Copy a tag from .nav-phone
  let $navPhone = $("#mobile__menu .nav-phone a");
  if ($navPhone.length) {
    let $phoneWrapper = $(".phone__wrapper");
    if ($phoneWrapper.length) {
      $phoneWrapper.append($navPhone.detach());
    }
  }

  // Two column menu
  let $twoColMenu = $(".two-col");
  if ($twoColMenu.length) {
    $twoColMenu.each(function() {
      let $this = $(this);
      $this
        .find("ul.sub-menu")
        .find("li")
        .wrapAll(
          '<li class="sub-menu-wrapper"><ul class="sub-menu-inner"></ul></li>',
        );
    });
  }

  let $header = $(".header");
  let $donateBtn = $(".donate__btn-wrapper--footer");

  if ($header.length && $donateBtn.length) {
    let headerObserver = new IntersectionObserver(
      function(entries) {
        entries.forEach(function(entry) {
          if (!entry.isIntersecting) {
            $donateBtn.addClass("active");
          } else {
            $donateBtn.removeClass("active");
          }
        });
      },
      { threshold: 0 },
    );

    headerObserver.observe($header[0]);
  }

  // ADA -------------------------------------------------------------------------------------------------------------
  $("#main__nav > ul > li > a, #top__nav > ul > li > a").on(
    "focus",
    function() {
      let $nav = $(this).closest("nav");
      $nav.find("> ul > li > .sub-menu").slideUp();
      $(this)
        .next(".sub-menu")
        .slideDown();
    },
  );
});



// WEBPACK FOOTER //
// ./resources/assets/scripts/app.js